import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { DOSSIER_DETAIL_TAB_PATHS, NO_PERMISSION_PATH } from '../../constants/paths.constants';
import { PERMISSIONS } from '../../constants/permissions.constants';
import { currentUserSelector } from '../../selectors/auth.selectors';
import permissionsService from '../../services/permissions/permissions.service';

export const useDossierRouteGuard = (isLoading, dossier) => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector(currentUserSelector);

  const currentTabPath = `/${location.pathname?.split('/')?.[3] ?? ''}`;
  const currentTab = Object.values(DOSSIER_DETAIL_TAB_PATHS)?.find((tab) => tab.path === currentTabPath);

  const readPermissions = currentTab?.readPermissions?.[dossier?.type] ?? [];
  const writePermissions = currentTab?.writePermissions?.[dossier?.type] ?? [];
  const write = writePermissions?.some((p) => user?.permissions?.includes(p.permission));
  const writeOnlyIfStakeholder =
    !user?.permissions?.includes(PERMISSIONS.STAD_DISPATCH) &&
    writePermissions?.some((p) => user?.permissions?.includes(p.permission) && p.onlyIfStakeholderInTab);

  const read = readPermissions?.some((p) => user?.permissions?.includes(p.permission));

  const dossierLoaded = !isLoading && !!dossier;
  if (dossierLoaded && !read && !write) {
    navigate(NO_PERMISSION_PATH);
  }

  if (dossierLoaded && !permissionsService.canAccessDossierTab(user, dossier, currentTab)) {
    navigate(NO_PERMISSION_PATH);
  }

  const result = {
    read,
    write,
    writeOnlyIfStakeholder
  };
  return result;
};
